import { memo } from 'react';
import { imageFromCDN } from '../../lib/utils';

export const FakeGraph = memo(
  () => <img alt="kaavio" src={imageFromCDN('/emptyLineGraph.svg')} width={512.625} height={280} />,
  () => true
);
